export const EMPTY_ROW = {
  id: undefined,
  countryJurisdiction: undefined,
  furtherDetails: undefined,
  noTinReasonID: undefined,
  tin: undefined,
};
